import { IConnectedApplicationType } from '../serverApi/types/ConnectedApplicationType';
import { IConnectedApplicationInfo } from './ConnectedApplicationInfo';


// maps from the wire "Type" to the internal "Info" representation
// this would be straighforward except we are mapping "clientId" to "id"
// because there is code that likes "id"
export module ConnectedApplicationInfoMapper {

  export function map(
    rows: IConnectedApplicationType[]
  ): IConnectedApplicationInfo[] {
    return rows.map((m: IConnectedApplicationType) => {
      return {
        contentType: 'connectedApplication',
        createdAt: m.createdAt,
        domainSafelist: m.domainSafelist,
        enabled: m.enabled,
        id: m.clientId,
        name: m.name,
        projectId: m.projectId,
        unrestrictedEmbedding: m.unrestrictedEmbedding,
        domainSafelistForGrid: m.unrestrictedEmbedding ? undefined : m.domainSafelist
      };
    });
  }
}